import { Box, Text, makeUclComponent } from '@rbilabs/universal-components';

import { CCPAButtonLink } from 'pages/account/ccpa-button-link';
import { getDesignToken, primitive } from 'styles/constants';
const footerTextProps = {
  color: primitive.$mayoEggWhite,
  fontSize: 'xs',
};

export const FooterText = Text.withConfig({
  ...footerTextProps,
});

export const FooterCCPAButtonLink = makeUclComponent(CCPAButtonLink).withConfig({
  ...footerTextProps,
  _text: {
    ...footerTextProps,
  },

  justifyContent: { base: 'center' },
});

export const FooterWrapper = Box.withConfig({
  background: getDesignToken('color-contrast-background'),
  padding: '$4',
  textAlign: 'center',
  justifyContent: 'center',
  flexDirection: { base: 'column', lg: 'row' },
});
